import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import { useFormikContext } from 'formik';
import EditableCard, {
  Edit,
  EditContent,
  EditTitle,
  ReadOnly,
  ReadOnlyContent
} from '~/modules/common/components/EditableCard';
import BillingCardReadOnly from './BillingCardReadOnly';
import BillingCardEditableTitle from './BillingCardEditableTitle';
import BillingCardEditable from './BillingCardEditable';

export const billingCardResourceKeys = {
  cardTitle: 'billingCard.cardTitle',
  schedule: 'billingCard.title.schedule',
  paymentTermNet: 'billingCard.subTitleValue.net',
  paymentTerm: 'billingCard.subTitle.paymentTerm',
  structure: 'billingCard.title.structure',
  billLineItemsBy: 'billingCard.subTitle.billLineItemsBy',
  defaults: 'billingCard.title.defaults',
  billingCurrency: 'billingCard.subTitle.invoiceCurrency',
  taxProfile: 'billingCard.subTitle.taxProfile',
  noTaxProfile: 'project.noTaxProfile',
  invoiceTemplate: 'billingCard.subTitle.invoiceTemplate',
  noInvoiceTemplate: 'project.noInvoiceTemplate',
  description: 'billingCard.subTitle.description',
  internalNotes: 'billingCard.subTitle.internalNotes',
  showComments: 'billingCard.subTitle.showComments',
  poNumber: 'billingCard.subTitle.poNumber'
};

const avatar = <RequestQuoteIcon />;
const title = <FormattedMessage id="billingCard.cardTitle" />;

export const BillingCard = ({ editable }) => {
  const {
    handleReset,
    handleSubmit,
    isValid,
    isSubmitting
  } = useFormikContext();

  return (
    <EditableCard
      editable={editable}
      dataQeId="BillingCard"
      ariaLabelKey="billingCard.billingCardDialog"
    >
      <ReadOnly avatar={avatar} title={title}>
        <ReadOnlyContent>
          <BillingCardReadOnly
            billingCardResourceKeys={billingCardResourceKeys}
          />
        </ReadOnlyContent>
      </ReadOnly>
      <Edit
        saveable={isValid && !isSubmitting}
        onCancel={handleReset}
        onSave={handleSubmit}
      >
        <EditTitle>
          <BillingCardEditableTitle />
        </EditTitle>
        <EditContent>
          <BillingCardEditable
            billingCardResourceKeys={billingCardResourceKeys}
            isSubmitting={isSubmitting}
          />
        </EditContent>
      </Edit>
    </EditableCard>
  );
};

BillingCard.propTypes = {
  editable: PropTypes.bool
};

export default BillingCard;
